import { createStore } from 'vuex';
import { removeToken } from '@/utils/auth';
import {
  readChatSession,
  writeChatSession,
  type ChatSessionStored,
} from '@/utils/chat_session_storage';
import {
  writeRuntimeQueryParams,
} from '@/utils/chat_runtime_params';

export default createStore({
  state: {
    isLoggedIn: false,
    session: null as ChatSessionStored | null,
  },
  getters: {
    isLoggedIn: (state) => state.isLoggedIn,
    session: (state) => state.session,
  },
  mutations: {
    SET_LOGIN_STATE(state, payload: boolean) {
      state.isLoggedIn = payload;
    },
    SET_SESSION(state, payload: ChatSessionStored | null) {
      state.session = payload;
    },
  },
  actions: {
    FedLogOut({ commit }) {
      removeToken();
      sessionStorage.removeItem('gx_chat_im_session');
      sessionStorage.removeItem('gx_chat_runtime_query_params');
      sessionStorage.removeItem('gx_chat_url_stripped_reloaded');
      commit('SET_LOGIN_STATE', false);
      commit('SET_SESSION', null);
    },
    SetSession({ commit }, session: ChatSessionStored) {
      commit('SET_SESSION', session);
      commit('SET_LOGIN_STATE', true);
    },
  },
  modules: {
  },
});
